import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import TransportPaymentRow from './TransportPaymentRow'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormTitle from '../../../../library/form/components/FormTitle';

import { UiView, UiViewHeading, UiTitle } from "../../../../library/layout/Index";

const TransportPayment = (props) => {
    const { formObject, viewData } = props;

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Payment Details' />
                </UiTitle>
            </UiViewHeading>
            <div className="listItemDetails">
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th><SarasTrans value="Row ID" /></th>
                            <th><SarasTrans value="Transport Date" /></th>
                            <th><SarasTrans value="Transport ID" /></th>
                            <th><SarasTrans value="Truck Number" /></th>
                            <th><SarasTrans value="From Port" /></th>
                            <th><SarasTrans value="To Port" /></th>
                            <th><SarasTrans value="Weight" /></th>
                            <th><SarasTrans value="KT" /></th>
                            <th><SarasTrans value="Amount" /></th>
                            <th><SarasTrans value="Action" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.values(viewData).map((row, index) => (
                                <TransportPaymentRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </UiView >
    )
}

export default withView(TransportPayment, "voucherDetail", "voucherFooter")